import { httpRequest } from '@/apis/request'

enum Apis {
  Search = 'documentations_list',
}

/** 获取可搜索节点 */
export async function getSearchAnchor() {
  return httpRequest.get(Apis.Search)
}
